import { render } from "./ModalCargando.vue?vue&type=template&id=62bbfc10"
import script from "./ModalCargando.vue?vue&type=script&lang=js"
export * from "./ModalCargando.vue?vue&type=script&lang=js"

import "./ModalCargando.vue?vue&type=style&index=0&id=62bbfc10&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__